import styled from '@emotion/styled';

export const Back = styled.div`
  position: absolute;
  top: 0;
  left: 0;
`;

export const Content = styled.div`
  margin-top: 10%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  justify-items: center;
  @media (max-width: 500px) {
    margin-top: 20%;
  }
`;

export const Container = styled.div`
  position: relative;
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  justify-items: center;
  a {
    position: absolute;
    margin: 0px;
    text-decoration: none;
    height: 20px;
    width: 100px;
  }
  h2 {
    font-size: 3rem;
    margin: 1.5rem 0;
  }
  p {
    margin: 3% 0px;
    font-style: normal;
    font-weight: normal;
    font-size: 1.2rem;
    color: #000000;
  }
  form {
    width: 100%;
    max-width: 450px;
    @media (max-width: 500px) {
      margin-top: 5%;
    }
  }
`;

export const ForgetPassword = styled.div`
  margin-top: 30px;
  width: 400px;
  font-style: normal;
  font-weight: normal;
  font-size: 1.5rem;
  text-decoration-line: underline;
  color: #9aa0ba;
`;

export const Right = styled.div`
  position: relative;
  width: 28.3%;
  img {
    width: 30.1rem;
    height: 100vh;
    position: absolute;
    opacity: 0.7;
    z-index: -1;
    object-fit: cover;
  }
  h2 {
    margin: 0;
    padding: 0;
    font-family: Metropolis;
    font-size: 5em;
    text-align: center;
    color: #fefeff;
    text-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
  }
  @media (max-width: 1200px) {
    display: none;
  }
`;

export const Cancel = styled.a`
  margin-top: 2rem;
  font-style: normal;
  font-weight: bold;
  font-size: 1.3rem;
  line-height: 18px;
  text-align: center;
  color: #db3535;
`;
